import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { StyledAssetsCard } from "./stylesHome";
import ImageItemActions from "../../common/ImageItemActions";
import { connect } from "react-redux";
import { selectCard, unSelectCard } from "../../../_actions/folderActions";
import { TldrCheckbox } from "./statelessView";
import TemplateItemActions from "../../common/TemplateItemActions";
import axios from "axios";
import EditableLabel from "../../common/EditableLabel";
import { getCursorTypeFromAssetProcessingStatus } from "../../../_utils/mediaPanels";
import { isMobileView } from '@simplified-workspace/shared/util';

class AssetsCardView extends React.Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
      isHovering: false,
      isTitleHovering: false,
      originalTitle: this.props.payload.payload.name || "",
      title: this.props.payload.payload.name || "",
      status: this.props.payload.payload.publish,
      showCloneModal: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { payload, selectedCards } = this.props;
    const assetId = payload.content.meta.content_id || payload.content.meta.id;

    if (this.props !== prevProps) {
      if (this.state.title === "") {
        // update title for the first time
        this.setState({
          title: payload.payload.name || "",
          originalTitle: payload.payload.name || "",
          isChecked: selectedCards.find((item) => item.content_id === assetId),
        });
      } else {
        this.setState({
          isChecked: selectedCards.find((item) => item.content_id === assetId),
        });
      }
    }
  }

  handleMouseEnter = () => {
    this.setState({
      ...this.state,
      isHovering: true,
    });
  };

  handleMouseLeave = () => {
    this.setState({
      ...this.state,
      isHovering: false,
    });
  };

  onRenameHandler = (e) => {
    if (this.state.title !== this.state.originalTitle) {
      if (this.state.title.trim().length > 0) {
        this.props.onEditNameHandler(this.state.title, this.props.payload);
        this.setState({
          ...this.state,
          originalTitle: this.state.title,
        });
      } else {
        this.setState({
          ...this.state,
          title: this.state.originalTitle,
        });
        return;
      }
    }
  };

  onCardClickHandler = (isChecked) => {
    const { payload, contentType } = this.props;
    const assetId = payload.content.meta.content_id || payload.content.meta.id;
    const selectedAsset = {
      content_type: contentType,
      content_id: assetId,
    };

    if (isChecked) {
      this.props.selectCard(selectedAsset);
    } else {
      this.props.unSelectCard(selectedAsset);
    }
    this.setState({
      ...this.state,
      isChecked: isChecked,
    });
  };

  handleTitleMouseEnter = () => {
    this.setState({ isTitleHovering: true });
  };

  handleTitleMouseLeave = () => {
    this.setState({ isTitleHovering: false });
  };

  handleAssetNameFocus = (text) => {};

  handleAssetNameFocusOut = (text) => {
    this.setState(
      {
        title: text,
      },
      () => {
        this.onRenameHandler();
      }
    );
  };

  render() {
    const {
      type,
      hasAction,
      modalFor,
      templateActionMenu,
      isDragging,
      currentFolderId,
      showRemoveFromFolder,
      showExtraOptions,
      assetStatus,
    } = this.props;
    const { meta } = this.props.payload.content || { meta: {} };
    const { isHovering, isChecked, title, showCloneModal, isTitleHovering } =
      this.state;
    const assetId = meta.content_id || meta.id;

    const cursor = getCursorTypeFromAssetProcessingStatus(assetStatus);

    return (
      <StyledAssetsCard
        autoHeight={this.props.autoHeight}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        cursor={cursor}
      >
        <div
          className="holder"
          onClick={() => this.onCardClickHandler(!isChecked)}
        >
          {this.props.children}
        </div>

        <div className="footer">
          <div
            className="title-content"
            onMouseEnter={this.handleTitleMouseEnter}
            onMouseLeave={this.handleTitleMouseLeave}
          >
            <EditableLabel
              text={this.state.title}
              labelClassName="assetnamevalue"
              inputClassName="projectnameinput"
              onFocus={this.handleAssetNameFocus}
              onFocusOut={this.handleAssetNameFocusOut}
              showIcon={isTitleHovering}
              inputMaxLength={100}
              labelPlaceHolder="Name of the Asset"
              labelTextClassName="project-name-label"
            />
          </div>

          <span className="date">{this.props.payload?.payload?.type}</span>
        </div>

        {isHovering || isChecked ? (
          <TldrCheckbox
            checked={isChecked}
            onCheck={(value) => this.onCardClickHandler(value)}
            hasAbsolutePosition
            description={isChecked ? "Unselect" : "Select"}
          />
        ) : null}

        {this.props.selectedCards.length > 0 && (
          <TldrCheckbox
            checked={isChecked}
            onCheck={(value) => this.onCardClickHandler(value)}
            hasAbsolutePosition
            description={isChecked ? "Unselect" : "Select"}
          />
        )}

        {((isHovering && !isMobileView()) || isMobileView()) && hasAction
          ? !templateActionMenu && (
              <ImageItemActions
                id={assetId}
                key={assetId}
                type={type}
                modalFor={modalFor}
                onActionComplete={this.props.onActionComplete}
                currentFolderId={currentFolderId}
                showRemoveFromFolder={showRemoveFromFolder}
                showExtraOptions={showExtraOptions}
              />
            )
          : null}

        {((isHovering && !isMobileView()) || isMobileView()) && hasAction
          ? templateActionMenu && (
              <TemplateItemActions
                id={assetId}
                title={meta.title}
                type={type}
                modalFor={modalFor}
                payload={this.props.payload}
                onActionComplete={this.props.onActionComplete}
                currentFolderId={currentFolderId}
                showRemoveFromFolder={showRemoveFromFolder}
                showExtraOptions={showExtraOptions}
              />
            )
          : null}
      </StyledAssetsCard>
    );
  }
}

AssetsCardView.defaulProps = {
  onActionComplete: () => {},
  currentFolderId: undefined,
  showRemoveFromFolder: false,
  showExtraOptions: false,
};

const mapStateToProps = (state) => ({
  isPanelShowing: state.folders.isPanelShowing,
  selectedCards: state.folders.selectedCards,
});

const mapDispatchToProps = (dispatch) => ({
  selectCard: (payload) => dispatch(selectCard(payload)),
  unSelectCard: (payload) => dispatch(unSelectCard(payload)),
});

AssetsCardView.propTypes = {
  assetStatus: PropTypes.string,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AssetsCardView));
